import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import Component from '../../../components/Production/Form/OwnerDefectReport/index'
import { v2_ships } from '../../../actions/v2/projectAndVessel';
import { v2_user_by_roles } from '../../../actions/v2/user';
import { v2_state_districts } from '../../../actions/v2/masterData';
import { v3_fetchNewBuildingNCRIndexFields, v3_fetchNewBuildingOwnerDefectReportFields, v3_submitNewBuildingOwnerDefectReport, v3_upload_owner_defect_report_photo } from '../../../actions/v3/productionForm';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';

const OwnerDefectReport = (props) => {
    const location = useLocation();

    const { data } = location.state || {};
    const [state, setState] = useState({
        ship: { name: 'ship', value: '', options: [], error: '', isRequired: true },
        issueDate: { name: 'issueDate', value: '', error: '', isRequired: true },
        defectNumber: { name: 'defectNumber', value: '', error: '', isRequired: true },
        issuedBy: { name: 'issuedBy', value: '', options: [], error: '', isRequired: true },
        to: { name: 'to', value: '', options: [], error: '', isRequired: true },
        cc: { name: 'cc', value: '', options: [], error: '', isRequired: true },
        location: { name: 'location', value: '', options: [], error: '', isRequired: true },
        subject: { name: 'subject', value: '', error: '', isRequired: true },
        description: { name: 'description', value: '', error: '', isRequired: true },
        photos: { name: 'photos', value: [], error: '', isRequired: true },

        builderReply: { name: 'builderReply', value: '', error: '', isRequired: false },
        builderSignature: { name: 'builderSignature', value: '', error: '', isRequired: false },
        builderReplyDate: { name: 'builderReplyDate', value: '', error: '', isRequired: false },

        verifiedReply: { name: 'verifiedReply', value: '', error: '', isRequired: false },
        verifiedSignature: { name: 'verifiedSignature', value: '', error: '', isRequired: false },
        verifiedReplyDate: { name: 'verifiedReplyDate', value: '', error: '', isRequired: false },

        finalSubmit: { name: 'finalSubmit', value: false, error: '', isRequired: false },
    });
    const [showLoader, setShowLoader] = useState(false)
    useEffect(() => {
        
        const params = data ? JSON.parse(atob(data)) : null;
        if (params) {
            setShowLoader(true);

            v3_fetchNewBuildingOwnerDefectReportFields(
                params.FORM_ID
            )
                .then((res) => {
                    if (res.status) {


                        if (params.FORM_ID) {
                            setState((prev) => ({
                                ...prev,
                                ship: { ...prev.ship, value: res.result?.SHIP_ID || '' },
                                issueDate: { ...prev.issueDate, value: res.result?.ISSUE_DATE || '' },
                                defectNumber: { ...prev.defectNumber, value: res.result?.DEFECT_NUMBER || '' },
                                issuedBy: { ...prev.issuedBy, value: res.result?.ISSUED_BY || '' },
                                to: { ...prev.to, value: res.result?.TO_USER || '' },
                                cc: { ...prev.cc, value: res.result?.CC_USER || '' },
                                location: { ...prev.location, value: res.result?.LOCATION || '' },
                                subject: { ...prev.subject, value: res.result?.SUBJECT || '' },
                                description: { ...prev.description, value: res.result?.DESCRIPTION || '' },
                                photos: { ...prev.photos, value: res.result?.PHOTOS || [] },

                                builderReply: { ...prev.builderReply, value: res.result?.BUILDER_REPLY || '' },
                                builderSignature: { ...prev.builderSignature, value: res.result?.BUILDER_SIGNATURE || '' },
                                builderReplyDate: { ...prev.builderReplyDate, value: res.result?.BUILDER_REPLY_DATE || '' },

                                verifiedReply: { ...prev.verifiedReply, value: res.result?.VERIFIED_REPLY || '' },
                                verifiedSignature: { ...prev.verifiedSignature, value: res.result?.VERIFIED_SIGNATURE || '' },
                                verifiedReplyDate: { ...prev.verifiedReplyDate, value: res.result?.VERIFIED_REPLY_DATE || '' },

                                finalSubmit: { ...prev.finalSubmit, value: Boolean(res.result?.FINAL_SUBMITTED) },
                            }));

                        }


                    } else {
                        toast.error(res.error);
                    }
                })
                .catch(() => toast.error('Something went wrong while fetching.'))
                .finally(() => setShowLoader(false));
        }

    }, []);
    const handlePhotoChange = async (e) => {
        const files = Array.from(e.target.files);

        for (const file of files) {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('shipId', state.ship.value);


            try {
                const res = await v3_upload_owner_defect_report_photo(formData);

                // Assuming API returns { fileName: 'uploaded_filename.jpg' }
                const uploadedFileName = res.result?.fileName;

                if (uploadedFileName) {
                    setState(prev => ({
                        ...prev,
                        photos: {
                            ...prev.photos,
                            value: [...prev.photos.value, uploadedFileName],
                            error: '',
                        }
                    }));
                }
            } catch (err) {
                console.error('Photo upload failed:', err);
                // You may also choose to set an error message
            }
        }
    };

    const onSubmit = async () => {
        
        // Step 1: Validate
        let isValid = true;
        const updatedState = { ...state };
        
        Object.keys(state).forEach((key) => {
            const field = state[key];
            if (field.isRequired && (!field.value || (Array.isArray(field.value) && field.value.length === 0))) {
                updatedState[key].error = 'This field is required';
                isValid = false;
            } else {
                updatedState[key].error = '';
            }
        });

        if (!isValid) {
            toast.error('Please fill all required fields');
            setState(updatedState);
            return;
        }


        // Step 3: Build model
        const model = {
            ship: state.ship.value,
            issueDate: state.issueDate.value,
            defectNumber: state.defectNumber.value,
            issuedBy: state.issuedBy.value,
            to: state.to.value,
            cc: state.cc.value,
            location: state.location.value,
            subject: state.subject.value,
            description: state.description.value,
            photos: btoa(JSON.stringify(state.photos.value)),
            builderReply: state.builderReply.value,
            builderSignature: state.builderSignature.value,
            builderReplyDate: state.builderReplyDate.value,
            verifiedReply: state.verifiedReply.value,
            verifiedSignature: state.verifiedSignature.value,
            verifiedReplyDate: state.verifiedReplyDate.value,
            finalSubmit: Number(state.finalSubmit.value),
        };

        // Step 4: Submit
        try {
            const res = await v3_submitNewBuildingOwnerDefectReport(model);
            if (res.status) {
                toast.success('Defect Report submitted successfully');
                props.history.push(constant.Authedcomponent.submittedOwnerDefectReport.url)
            } else {
                toast.error(res.message || 'Submission failed');
            }
        } catch (error) {
            toast.error('Server error. Please try again later.');
            console.error(error);
        }
    };


    useEffect(() => {
        v2_ships().then((res => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['ship']: {
                        ...prev['ship'],
                        options: res.result,
                        error: '', // Clear error on change
                    }
                }));
            }
        }))

        v2_user_by_roles().then((res => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['to']: {
                        ...prev['to'],
                        options: res.result,
                    },
                    ['cc']: {
                        ...prev['cc'],
                        options: res.result,
                    },
                    ['issuedBy']: {
                        ...prev['issuedBy'],
                        options: res.result,
                    }
                }));
            }
        }))

        v2_state_districts().then((res => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['to']: {
                        ...prev['to'],
                        options: res.result,
                    },
                    ['cc']: {
                        ...prev['cc'],
                        options: res.result,
                    },
                    ['cc']: {
                        ...prev['cc'],
                        options: res.result,
                    }
                }));
            }
        }))


    }, [])

    const handleChange = (e) => {
        const { name: field, value } = e.target;
        setState(prev => ({
            ...prev,
            [field]: {
                ...prev[field],
                value: value,
                error: '', // Clear error on change
            }
        }));
    };

    return (
        <Layout
            title={'Owner’s Defect Report'}
        >
            <Component
                state={state}
                onSubmit={onSubmit}
                isFinalSubmitting={state.finalSubmit.value}
                setIsFinalSubmitting={() => setState((prev) => ({
                    ...prev,
                    finalSubmit: { ...prev.finalSubmit, value: !state.finalSubmit.value },
                }))}
                handleChange={handleChange}
                handlePhotoChange={handlePhotoChange}
            />

        </Layout>
    )
}

export default OwnerDefectReport